<ng-container>
  <mat-dialog-content>
    <form>
      <mat-card>
        <mat-radio-group [disabled]="isRadioGroupDisabled" class="display-hours-radio-group" name="displayHoursList">
          <label class="display-hours-label"><b>Display Option:</b></label>
          <mat-radio-button [checked]="isDisplayHoursRadioBtnSelected(hour)" class="display-hours-radio-btn" *ngFor="let hour of hoursTags"
            [value]="hour.tagName" (change)="displayHoursRadioBtnChanged($event)">{{hour.tagName | tagName }}</mat-radio-button>
          <mat-radio-button [checked]="isDisplayHoursRadioBtnSelected({tagName: 'customHours'})" class="display-hours-radio-btn"
            [value]="'customHours'" (change)="displayHoursRadioBtnChanged($event)">Custom Hours</mat-radio-button>
        </mat-radio-group>
      </mat-card>
      <br/>
      <mat-card *ngIf="isDisplayHoursRadioBtnSelected({tagName: 'customHours'})">
        <app-business-hours-table #businessHoursTable [business]="business"></app-business-hours-table>
      </mat-card>
      <br/>
      <mat-card>
        <mat-form-field #footerClosedHolidays class="closed-holidays-field">
          <textarea class="hours-Exceptions-TextArea" appAutoAdjustTextArea matInput #closedHolidaysField placeholder="Write Holiday Exceptions Here"
            name="hoursExceptions" [(ngModel)]="hoursExceptions"></textarea>
        </mat-form-field>
        <button mat-icon-button id="saveHoursExceptionBtn" (click)="updateHoursException(hoursExceptions)">
          <mat-icon>save</mat-icon>
        </button>
      </mat-card>
      <br/>
    </form>
  </mat-dialog-content>
</ng-container>
<mat-dialog-actions>
  <button [disabled]="disableClose" class="mat-raised-button" (click)="closeDialog()">Close</button>
</mat-dialog-actions>